<div>
  <h1 class="eca-skip-link-focus-target" tabindex="-1">Security UI</h1>
  <h3>Access Denied</h3>
  <p>We are sorry, but you do not have sufficient permission to proceed.</p>
</div>
